import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import {
    getNoLigne,
    getMaxNoLigne,
    getArrayField,
    bskReq,
} from '@core/_utils/tools.utils';
import { dateFormat } from '@core/_utils/date.utils';
import { getComputedDate } from '@core/_utils/date.utils';
import { LineRequest } from '@pages/requests/line-request';
import { Visibility, ActionDate } from '@documalis/_const/const';
import { Operators } from '@documalis/_const/const';
import { ADD_ID } from '@documalis/_const/const';
import { AutofocusDirective } from '@directives/auto-focus.directive';

import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HeaderRequest } from '../../header-request';

@Component({
    selector: 'app-form-requests',
    templateUrl: './form-requests.component.html',
    styleUrls: ['./form-requests.component.scss'],
    providers: [AutofocusDirective],
})
export class FormRequestsComponent extends FormBase implements OnInit, OnDestroy {
    public requestForm: FormGroup;
    public currentList = [];
    public validClick = false;
    public listColumns: any[];
    public selectedItem: LineRequest;
    public listVisibility = [];
    public listOperator = [];
    public indexRequestList = [];
    public displayDet: boolean = false;
    public visibility = 0;
    public groupListUsed = [];
    public userListUsed = [];
    public isAdmin = false;
    public operatorList = [];
    public listActionDate = [];
    public isBskReq: string = '';

    @Input()
    public request: HeaderRequest = null;

    @Input()
    public requestItemList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public resultList = [];

    @Input()
    public customEditorList = [];    

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.requestForm = this.formBuilder.group({
            id: null,
            name: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
            desc: null,
            visibility: this.isAdmin ? [null, [Validators.required]] : [null],
            filterType: 'idx',
            label: null,
            groupListUsed: null,
            userListUsed: null,
            idresult: null,
            emptyField: true,
        });
        this.initialization();
        this.selectedItem = new LineRequest();
        this.visibility = null;
    }
    
    ngOnInit() {
        this.currentList = this.getFilter('idx');       
        if (this.request !== null) {
                this.request.notifyParent.subscribe(success => {
                this.requestForm.patchValue(this.request);
                this.indexRequestList = JSON.parse(JSON.stringify(this.request.reqDetail));
                this.visibility = this.request.visibility;
                this.isBskReq = bskReq('Name', this.indexRequestList);
            })
        }
    }

    ngOnDestroy() {
        if (this.request !== null) {            
            this.request.notifyParent.unsubscribe()
        }
    }

    public onChangeVisibility($event) {
        this.visibility = $event.value;
    }

    public updateIndex(index) {
        this.displayDet = true;
        this.selectedItem.Clear();
        Object.assign(this.selectedItem, index);
        this.selectedItem = this.setDetailIndex(index, this.selectedItem);
        this.updateCmbList(false);
    }

    private setDetailIndex(aIndex, aSelectedItem) {
        var wItem: LineRequest;
        var wIndex = -1;
        wItem = new LineRequest();
        wIndex = getNoLigne(this.indexRequestList, aIndex.noligne);
        Object.assign(wItem, aSelectedItem);
        Object.assign(wItem, this.indexRequestList[wIndex]);
        return wItem;
    }

    private updateCmbList(aAdd) {
        let wIndate: any;
        this.selectedItem.loadOperator(this.selectedItem.Type, this.operatorList);
        this.selectedItem.ListActionDate = [...this.listActionDate];
        if (aAdd === true) {
            wIndate = {
                label: dateFormat(getComputedDate('TNow'), 'dd/MM/yyyy'),
                value: 'TInDate',
            };
            this.selectedItem.ListActionDate.unshift(wIndate);
        }
    }

    public deleteIndex(aIndex) {
        var wIndex = -1;
        wIndex = getNoLigne(this.indexRequestList, aIndex.noligne);
        this.indexRequestList.splice(wIndex, 1);
        this.isBskReq = bskReq('Name', this.indexRequestList);
    }

    public moveToTarget(event) {
        this.displayDet = true;
        this.selectedItem.Clear();
        Object.assign(this.selectedItem, event.data);
        this.updateCmbList(true);
        this.selectedItem.noligne = ADD_ID;
    }

    public validItem(event) {
        this.displayDet = false;
        if (event.noligne === ADD_ID) {
            this.addToListIndex(event);
        } else {
            this.updateListIndex(event);
        }
        this.isBskReq = bskReq('Name', this.indexRequestList);
    }

    public closeCriteria() {
        this.displayDet = false;
    }

    private addToListIndex(aData) {
        let wIndex: any;
        var wLign = -1;
        wLign = getMaxNoLigne(this.indexRequestList);
        wLign++;
        wIndex = this.setCriteria(aData, wLign);
        this.indexRequestList.push(wIndex);
    }

    private updateListIndex(aData) {
        var wIndex = -1;
        wIndex = getNoLigne(this.indexRequestList, aData.noligne);
        if (wIndex !== -1) {
            this.indexRequestList[wIndex] = this.setCriteria(aData, aData.noligne);
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Err_IdxDoc'));
        }
    }

    private setCriteria(aData, aNolign) {
        let wIndex: any;
        wIndex = new Object();
        wIndex = {
            Name: aData.Name,
            Label: aData.Label,
            noligne: aNolign,
            Operat: aData.Operat,
            Visible: aData.Visible,
            Search: aData.Search,
            DefaultValue: getArrayField(aData.DefaultValue),
            Type: aData.Type,
            DisplayDefault: aData.DisplayDefault,
            ListActionDate: aData.ListActionDate,
        };
        return wIndex;
    }

    public onFilterClick(event) {
        this.currentList = [];
        this.currentList = this.getFilter(event);
    }

    public validate(aDuplicate) {
        let wRequest: any;

        if (!this.isAdmin) {
            this.requestForm.value.visibility = 2;
            this.requestForm.value.userListUsed = [];
            this.requestForm.value.userListUsed.push(this.auth.getUser());
        }

        wRequest = new Object();
        wRequest = {
            duplicate: aDuplicate,
            entete: this.requestForm.value,
            detail: this.indexRequestList,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.indexRequestList.length === 0) {
            this._messageService.addErrorNoStick(this.translate.instant('NoIdx'));
            return;
        }
        if (this.requestForm.invalid) {
            this.getErrorsInputs(error, this.requestForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.request);
    }

    private getFilter(aType) {
        let wResult = [];
        const type = {
            idx: this.getList(this.indexList),
            doc: this.getList(this.propertiesList),
            bsk: this.getList(this.propBskList),
            sys: this.getList(this.systemList),
        };
        if (type[aType]) {
            wResult = type[aType]();
        }
        return wResult;
    }

    private getList(aList) {
        return () => {
            return aList;
        };
    }

    private initialization() {
        this.operatorList = [];
        this.listActionDate = [];
        this.listVisibility = [];
        this.listOperator = [];
        this.keys = {
            name: {
                label: this.translate.instant('Name'),
                pattern: '',
            },
            visibility: {
                label: this.translate.instant('Visibility'),
                pattern: '',
            },
        };

        this.listColumns = [
            {
                field: 'Name',
                header: this.translate.instant('Name'),
            },
            {
                field: 'Label',
                header: this.translate.instant('Label'),
            },
        ];
        
        Operators.forEach(item => {
            this.operatorList.push({ id: item.id, name: this.translate.instant(item.type), type: item.type});            
        })
        
        ActionDate.forEach(item => {
            this.listActionDate.push({ label: this.translate.instant(item.value), value: item.value});            
        })

        Visibility.forEach(item => {            
            this.listVisibility.push({ label: item.name, value: item.id });
        });  

        Operators.forEach(item => {            
            this.listOperator.push({ label: item.type, value: item.id });
        });  
    }
}
